import { Tag } from 'antd';
import React, { ReactElement } from 'react';
import { IDictionary } from '~utilities/IDictionary';
import InterestMethodEnum from '../../Api/Investment/InterestMethodEnum';
import IInvestment from '~Api/Investment/IInvestment';

const interestMethodClasses: IDictionary<string> = {
    [InterestMethodEnum.InterestMethod360]: 'day360',
    [InterestMethodEnum.InterestMethod365]: 'day365',
};

const interestMethodLabels: IDictionary<string> = {
    [InterestMethodEnum.InterestMethod360]: '360 Day',
    [InterestMethodEnum.InterestMethod365]: '365 Day',
};

export default function InterestMethodTag(props: {
    investment: IInvestment;
}): ReactElement {
    const { investment } = props;

    return (
        <Tag className={`interest-method-tag ${interestMethodClasses[investment.interestMethod]}`}>
            {interestMethodLabels[investment.interestMethod]}
        </Tag>
    );
}